<template>
    <div id="status-table">
        <a-table
            :columns="columns"
            :dataSource="statuses"
            :pagination="false"
            class="custom-table2"
            rowKey="_id"
            size="small"
        >
            <div slot="_id" slot-scope="_id, item">
                <div class="button-container">
                    <a-button class="actionButton" @click="$emit('edit', _id)">
                        <div class="mr-1">{{ $t("message.edit") }}</div>
                        <ActionEdit />
                    </a-button>
                    <a-button class="actionButton" @click="deleteStatus(_id)">
                        <div class="mr-1">{{ $t("message.delete") }}</div>
                        <ActionDelete />
                    </a-button>
                </div>
            </div>
        </a-table>
    </div>
</template>

<script>
import ActionDelete from "./svg/ActionDelete";
import ActionEdit from "./svg/ActionEdit";
import { deleteTicketStatus } from "../api/ticket";

export default {
    name: "StatusTable",
    props: ["statuses", "edit", "deleted"],
    components: {
        ActionEdit,
        ActionDelete,
    },
    data() {
        return {
            columns: [
                {
                    title: this.$t("message.title"),
                    slot: "title",
                    dataIndex: "title",
                    width: "300px",
                },
                {
                    dataIndex: "_id",
                    title: this.$t("message.transactions"),
                    scopedSlots: { customRender: "_id" },
                    className: "transactions",
                    slot: "_id",
                    width: "200px",
                },
            ],
        };
    },
    methods: {
        deleteStatus(id) {
            deleteTicketStatus(id).then(() => this.$emit("deleted", id));
        },
    },
};
</script>

<style lang="scss" scoped>
#status-table {
    width: 100%;
    height: auto;

    tr {
        th {
            .transactions {
                text-align: right !important;
            }
        }

        td {
            max-width: none;
        }
    }

    .button-container {
        display: flex;

        .actionButton {
            display: flex;
            justify-content: center;
            align-items: center;

            &:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
}
</style>
